export enum ClaimRecoveryTypeReplacementVehicleCodeEnum {
    Car = 'VVGV', // Free car replacement
    Bicycle = 'VVGL', // Free loan bike
    TransportService = 'VVHB', // Transport service
    None = 'VVGE', // None/other
}
